var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfilemobiIcon = function SvgProfilemobiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M25.225 31.43v-3.143A6.284 6.284 0 0 0 18.935 22H7.929a6.284 6.284 0 0 0-6.29 6.286v3.143M12.645 14.143a6.29 6.29 0 0 0 6.29-6.286 6.29 6.29 0 0 0-6.29-6.286 6.29 6.29 0 0 0-6.29 6.286 6.29 6.29 0 0 0 6.29 6.286M25.226 14.143l3.145 3.143L34.661 11"
  })));
};
export default SvgProfilemobiIcon;